import {
	CECA_REFS,
	CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD
} from './constants';


function CECARound(num){
	// try to prevent float bugs
	let str = Number.parseFloat(num).toFixed(2);
	if (str.match(/\./)) {
    	str = str.replace(/\.?0+$/,'');
    }
	return str;
}

export default class AbriPackage {
	constructor(){
		this.refs = [];
		this.missing_refs = [];
		this.total_surface = 0;
		this._checkRefs();
		const homepage_price = this._findRef('SP-G3-2.55/3').prix_ht;
		if(window.homepage_price&&(window.homepage_price!==homepage_price)){
			alert("Incohérence prix page d'accueil");
		}
	}
	_reset = () => {
		this.refs = [];
		this.missing_refs = [];
		this.total_surface = 0;
	}

	get infos(){
		let total_price = 0;
		let total_mass = 0;
		const ceca_ref_count = new Map();
		this.refs.forEach((r)=>{
			if(!ceca_ref_count.has(r)){
				ceca_ref_count.set(r,1);
			}else{
				ceca_ref_count.set(r,ceca_ref_count.get(r)+1);
			}
		});
		const components = [];
		ceca_ref_count.forEach((count,ref)=>{
			const original_data = this._findRef(ref);
			const new_data = {
				mass: original_data.masse||0,
				price: original_data.prix_ht||0,
				desc: original_data.description,
				ref: original_data.ref_CECA,
				count: count
			};
			new_data.total_price = new_data.price*new_data.count;
			new_data.total_mass = new_data.mass*new_data.count;
			components.push(new_data);
		});
		components.forEach((c)=>{
			total_price += 	c.total_price;
			total_mass += 	c.total_mass;
		});
		const valid = !this.missing_refs.length;
		return {
			total_price:	valid?Math.ceil(total_price*100)/100:false,
			total_mass:		valid?Math.floor(total_mass*0.985):false,// pour les proceduriers
			total_surface:	this.total_surface,
			components: 	components,
			missing_refs: 	this.missing_refs,
			valid: 			valid
		};
	}

	_addSurface = (surface)=>{
		this.total_surface += surface;
	}
	_addRef = (ref,quantity=1)=>{
		const exists = this._findRef(ref);
		if(!exists){
			console.warn('ref error: '+ref);
			this.missing_refs.push(ref);
		}else{
			for (var i = 0; i < quantity; i++) {
				this.refs.push(ref);
			}
		}
	}
	_findRef = (ref)=>{
		let found = CECA_REFS.find(r=>(r.ref_CECA === ref));
		if(!found){
			found = CECA_REFS.find(r=>(r.ref_CECA.replaceAll(',','.') === ref));
		}
		return found;
	}
	_checkRefs = ()=>{
		// Check if main CECA refs exists
		// To automaticaly check if B3-LPH_RP-3.3 exists?
	}

	autoAddRefs(user_settings,big_settings_building){
		this._reset();
		const aR = this._addRef;
		const aS = this._addSurface;
		const u_s = user_settings;
		const b_s_b = big_settings_building;//

		

		// Order of injection is done within php quotation script
		const front_height = CECARound((u_s.height>CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD)?3.3:2.55);
		const back_height = CECARound(front_height-user_settings.depth*0.05);
		const depth = CECARound(u_s.depth);

		b_s_b.modules.forEach((module) => {
			const width = CECARound(module.width);
			aR('SP-G'+depth+'-'+front_height+'/'+width);
			aS(b_s_b.depth*module.width);
		});

		b_s_b.modules.forEach((module) => {
			const width = CECARound(module.width);
			if(module.front.activated){
				if(module.front.door){
					aR('B'+width+'-LPH_RP-'+front_height);
				}else{
					aR('B'+width+'-LP_HAUT-'+front_height);
				}
			}
			if(module.back.activated){
				if(module.back.door){
					aR('B'+width+'-LPBAS_RP-'+back_height);
				}else{
					aR('B'+width+'-LP_BAS-'+back_height);
				}
			}
		});
		if(u_s.wall_left){
			aR('B_PIGNON-G'+depth+'-'+front_height);
		}
		if(u_s.wall_right){
			aR('B_PIGNON-G'+depth+'-'+front_height);
		}
		if(u_s.atg){
			b_s_b.modules.forEach((module) => {
				aR('ATG-G'+depth+'/'+CECARound(module.width));
			});
		}
		if(u_s.atg_device){
			aR('PACL');
		}
		b_s_b.modules.forEach((module) => {
			if(module.transparent){
				aR('TRANS-G'+depth);
			}
		});
		if(u_s.delivery){
			aR('LIVRAISON');
		}
		b_s_b.modules.forEach((module,i) => {
			if(i){
				aR('REM-QTE');
			}
		});

		//accessoires facultatifs
		if(u_s.optional_accessories && u_s.optional_accessories.enabled){
			Object.keys(u_s.optional_accessories).forEach((k)=>{
				if(k.indexOf('num_')===0){
					aR(k.substr(4),u_s.optional_accessories[k]);
				}
			});
		}
	}

	exportCECARefs = ()=>{
		let csvContent = "data:text/csv;charset=utf-8,";
		csvContent += ['ref_CECA','masse','prix_ht','description'].join(",")+ "\n";

		CECA_REFS.forEach(function(infoArray, index){
			let dataString = "";
			dataString += String(infoArray.ref_CECA).replace(/,/g,'')+",";
			dataString += String(infoArray.masse).replace(/,/g,'')+",";
			dataString += String(infoArray.prix_ht).replace(/,/g,'')+",";
			dataString += String(infoArray.description).replace(/,/g,'');
			csvContent += dataString+ "\n";
		});

		let encodedUri = encodeURI(csvContent);
		window.open(encodedUri);
		console.log('Please pause AdBlock and allow popups');
	}
}
